import type { Store } from 'effector'
import type { ILogoSizes } from './lib'

import { createEffect, createEvent, createStore, sample } from 'effector'
import { triaDataVersion } from '~/app/environment'
import { register } from '~/core/repository'
import { model as sessionModel } from '~/entities/session'
import { withBrandingAssetVersion } from '~/shared/branding'
import { model as config, remote } from '~/shared/config'
import { createMediaQueryStore } from '~/shared/effector'
import { aye } from '~/shared/helpers'
import { logger } from '~/shared/logger'
import { decodeImg } from '~/shared/tools'
import { logoSizesFormatValidation } from './lib'

const WINDOW_MEDIUM_SIZE_IN_PX = 1440

export const init = createEvent()
export const parseFx = createEffect<string, ILogoSizes>(
  logoSizesFormatValidation
)

export const DEFAULT_LOGO_URL = '/img/logo.svg'

export const $logoUrl = createStore<string>(
  withBrandingAssetVersion(DEFAULT_LOGO_URL, triaDataVersion)
)
export const $logoHeight = createStore<string | null>(null)

const $isMediaMatchWithSize: Store<boolean> = createMediaQueryStore(
  `(min-width: ${WINDOW_MEDIUM_SIZE_IN_PX}px)`,
  true
)

export const $logoStringHeights: Store<string> = config.get(
  remote.tria_packageLogoHeight
)

export const $logoHeights = createStore<ILogoSizes | null>(null)

export const loadImageFx = createEffect<string, void, void>(decodeImg)

sample({
  clock: [sessionModel.$session, init],
  source: {
    session: sessionModel.$session,
  },
  fn: ({ session }) => {
    if (session?.logoUrl) {
      return withBrandingAssetVersion(session.logoUrl, triaDataVersion)
    }
    return withBrandingAssetVersion(DEFAULT_LOGO_URL, triaDataVersion)
  },
  target: loadImageFx,
})

sample({
  clock: loadImageFx.done,
  fn: ({ params }) => params,
  target: $logoUrl,
})

sample({
  clock: loadImageFx.fail,
  fn: () => withBrandingAssetVersion(DEFAULT_LOGO_URL, triaDataVersion),
  target: $logoUrl,
})

sample({ clock: $logoStringHeights, target: parseFx })

sample({
  clock: parseFx.doneData,
  target: $logoHeights,
})

sample({
  clock: [$logoHeights, $isMediaMatchWithSize],
  source: {
    logoHeights: $logoHeights,
    isLarge: $isMediaMatchWithSize,
  },
  filter: ({ logoHeights }) => aye(logoHeights),
  fn: ({ logoHeights, isLarge }) => {
    const { large, medium } = logoHeights!
    if (isLarge) return large
    return medium
  },
  target: $logoHeight,
})

sample({
  clock: parseFx.failData,
  fn: (error) => [error],
  target: logger.errorFx,
})

register($logoUrl, '$logoUrl')
